/**
 * Decide o que fazer com o chat depois que `prepararConversaDoPar` deixou a
 * conversa utilizável ao iniciar o atendimento.
 *
 * O hook do chat monta com a página, antes do "iniciar atendimento". Se leu a
 * conversa ainda encerrada, fica em `readOnly` (ou em `error`, quando o sid veio
 * do agendamento e a listagem foi pulada), sem Client. Reabrir por fora não o
 * faz reconectar sozinho: reinicia uma vez e baixa a flag. Enquanto o hook ainda
 * conecta, espera; em qualquer outro estado só baixa a flag, para um
 * `readOnly` posterior não causar um reinício não pedido.
 */
export function decidirReinicioDoChat(
  conversaPreparada: boolean,
  status: string
): { reiniciar: boolean; limpar: boolean } {
  if (!conversaPreparada || status === 'connecting') {
    return { reiniciar: false, limpar: false }
  }
  return {
    reiniciar: status === 'readOnly' || status === 'error',
    limpar: true,
  }
}
